import styled from 'styled-components';

export default styled.div`
	--line-height-content: 3rem;
	.accordion-container {
		display: grid;
		grid-template-columns: repeat(4, var(--reg-col)) calc(var(--reg-col) - var(--trigger-col)) var(--trigger-col);
		/* grid-template-columns: var(--reg-col) calc(80% - 0rem); */
		grid-template-rows: auto;
		grid-gap: var(--gap);
		padding-bottom: var(--gap);
		align-items: baseline;

		& > * {
			&:nth-child(odd) {
				grid-column: 1/2;
			}
			&:nth-child(even) {
				grid-column: 2/7;
			}
		}
	}

	.contacts-value {
		line-height: var(--line-height-content);
	}

	.entities-value {
		line-height: var(--line-height-content);
	}

	.countries-value {
		line-height: var(--line-height-content);
	}

	.group-roles-value {
		line-height: var(--line-height-content);
	}

	.engagements-value {
		line-height: var(--line-height-content);
	}

	.service-line-value {
		line-height: var(--line-height-content);
	}

	.roles-value {
		line-height: var(--line-height-content);
	}
`;
